/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateOnly, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailingListsSummaryDto as FeatureMailingListsMailingListsSummaryDto } from '../../models/feature/mailing-lists/mailing-lists-summary-dto';

export interface GetSummary$Params {
}

export function getSummary(http: HttpClient, rootUrl: string, params?: GetSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListsSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, getSummary.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<FeatureMailingListsMailingListsSummaryDto>;
    })
  );
}

getSummary.PATH = '/mailing-lists-page';

function reviveFeatureMailingListsMailingListsSummaryDto(value: any): any {
  if (value) {
    if (value["mailingLists"]) {
      for (let i0 = 0; i0 < value["mailingLists"].length; i0++) {
        if (value["mailingLists"][i0] != null) {
          value["mailingLists"][i0] = reviveFeatureMailingListsMailingListSummaryDto(value["mailingLists"][i0]);
        }
      }
    }
    if (value["usageHistory"]) {
      for (let i0 = 0; i0 < value["usageHistory"].length; i0++) {
        if (value["usageHistory"][i0] != null) {
          value["usageHistory"][i0] = reviveFeatureMailingListsUsageDatum(value["usageHistory"][i0]);
        }
      }
    }
    if (value["suppressionHistory"]) {
      for (let i0 = 0; i0 < value["suppressionHistory"].length; i0++) {
        if (value["suppressionHistory"][i0] != null) {
          value["suppressionHistory"][i0] = reviveFeatureMailingListsSuppressionGroup(value["suppressionHistory"][i0]);
        }
      }
    }
    if (value["suppressionRemovalHistory"]) {
      for (let i0 = 0; i0 < value["suppressionRemovalHistory"].length; i0++) {
        if (value["suppressionRemovalHistory"][i0] != null) {
          value["suppressionRemovalHistory"][i0] = reviveFeatureMailingListsSuppressionRemovalGroup(value["suppressionRemovalHistory"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureMailingListsMailingListSummaryDto(value: any): any {
  if (value) {
    if (value["lastUsed"] != null) {
      value["lastUsed"] = parseDateTime(value["lastUsed"]);
    }
  }
  return value;
}

function reviveFeatureMailingListsUsageDatum(value: any): any {
  if (value) {
    if (value["date"] != null) {
      value["date"] = parseDateOnly(value["date"]);
    }
  }
  return value;
}

function reviveFeatureMailingListsSuppressionGroup(value: any): any {
  if (value) {
    if (value["date"] != null) {
      value["date"] = parseDateOnly(value["date"]);
    }
  }
  return value;
}

function reviveFeatureMailingListsSuppressionRemovalGroup(value: any): any {
  if (value) {
    if (value["date"] != null) {
      value["date"] = parseDateOnly(value["date"]);
    }
    if (value["suppressionRemovals"]) {
      for (let i0 = 0; i0 < value["suppressionRemovals"].length; i0++) {
        if (value["suppressionRemovals"][i0] != null) {
          value["suppressionRemovals"][i0] = reviveFeatureMailingListsSuppressionRemovalDatum(value["suppressionRemovals"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureMailingListsSuppressionRemovalDatum(value: any): any {
  if (value) {
    if (value["addedAt"] != null) {
      value["addedAt"] = parseDateTime(value["addedAt"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveFeatureMailingListsMailingListsSummaryDto(body);
  }
  return body;
}
